import React from 'react';

const DashboardReferralCard = ({ onShare, t }) => {
  return (
    <section className="t-flex t-flex-col t-gap-5 t-rounded-[14px] t-border-2 t-border-butter t-bg-butter-soft t-px-6 t-py-5 t-shadow-[0_0_0_4px_rgba(246,225,71,0.28)] md:t-flex-row md:t-items-center md:t-justify-between">
      <div>
        <span className="t-mb-2 t-inline-flex t-rounded-md t-bg-navy t-px-2.5 t-py-1 t-text-[11px] t-font-extrabold t-uppercase t-tracking-[0.06em] t-text-butter">
          {t('Dashboard_Referral_Badge')}
        </span>
        <h3 className="t-m-0 t-font-serif t-text-lg t-font-normal t-leading-tight t-text-navy">
          {t('Dashboard_Referral_Title')}
        </h3>
        <p className="t-m-0 t-mt-2 t-max-w-[460px] t-text-sm t-leading-snug t-text-[#5c5430]">
          {t('Dashboard_Referral_Body')}
        </p>
      </div>
      <div className="t-flex t-flex-col t-gap-3 sm:t-flex-row sm:t-items-center">
        <span className="t-text-sm t-font-extrabold t-text-navy">€20 / €20</span>
        <button
          type="button"
          className="t-rounded-full t-border-0 t-bg-navy t-px-6 t-py-3 t-text-sm t-font-extrabold t-text-white"
          onClick={onShare}
        >
          {t('Dashboard_Referral_Cta')}
        </button>
      </div>
    </section>
  );
};

export default DashboardReferralCard;
